import { VNode, h, defineComponent } from 'vue';
import { box, button, container, loader, logo, message, namedLink, pageSubtitle } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';
import { logout } from '@/ui/auth/auth';
import { useTask } from '@/ui/concerns';

export const LogoutPage = defineComponent({
  name: 'LogoutPage',
  setup() {
    const logoutTask = useTask(
      () => logout(),
    );

    return function render(): VNode {
      const error = message('error', [
        pageSubtitle(t('auth.log-out-fail')),
        button(t('common.retry'), logoutTask.run),
      ]);

      return container(
        [
          logo(),
          box([
            loader('div', logoutTask, [
              h('template', { slot: 'error' }, [error]),
              message('info', [h('span', t('auth.log-out-safe'))]),
              namedLink(t('auth.log-in-back'), 'login'),
            ], false),
          ]),
        ],
        'small',
      );
    };
  },
});
